import { render, staticRenderFns } from "./r-currency-page.vue?vue&type=template&id=30fc2b66"
import script from "./r-currency-page.vue?vue&type=script&lang=js"
export * from "./r-currency-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30fc2b66')) {
      api.createRecord('30fc2b66', component.options)
    } else {
      api.reload('30fc2b66', component.options)
    }
    module.hot.accept("./r-currency-page.vue?vue&type=template&id=30fc2b66", function () {
      api.rerender('30fc2b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-page.vue"
export default component.exports